export const en = {
  // Common
  common: {
    viewProducts: 'View Products',
    consultNow: 'Consult Now',
    learnMore: 'Learn More',
    experienceNow: 'Experience Now',
    buyNow: 'Buy Now',
    close: 'Close',
    submit: 'Submit',
    cancel: 'Cancel',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Info'
  },

  messages: {
    common: {
      success: 'Operation successful',
      error: 'An error occurred. Please try again later',
      warning: 'Notice',
      saved: 'Saved',
      updated: 'Updated',
      deleted: 'Deleted'
    },
    auth: {
      loginSuccess: 'Login successful',
      loginFailed: 'Login failed',
      registerSuccess: 'Registration successful',
      registerFailed: 'Registration failed',
      pleaseLogin: 'Please log in first',
      accountNotActivated: 'Account not activated',
      resendVerificationCode: 'Resend verification code',
      verificationCodeSent: 'Verification code sent, please check your email',
      verificationCodeResent: 'Verification code resent, please check your email',
      sendFailed: 'Send failed',
      emailAlreadyRegistered: 'This email may already be registered. If verification is not completed, resend verification code?',
      resendCode: 'Resend',
      verificationRequired: 'Verification code sent, please check your email',
      accountNotActivatedInfo: 'Account not activated, you can enter verification code or choose to resend',
      verificationSuccess: 'Verification successful, account activated, please login',
      verificationFailed: 'Verification failed',
      pleaseEnterEmailAndCode: 'Please enter email and verification code',
      pleaseEnterEmail: 'Please enter email',
      pleaseEnterPassword: 'Please enter password',
      pleaseEnterName: 'Please enter name',
      pleaseConfirmPassword: 'Please confirm password',
      passwordMismatch: 'Passwords do not match',
      pleaseEnterEmailOrPhone: 'Please provide email or phone number',
      pleaseEnterVerificationCode: 'Please enter 4-digit verification code',
      verificationCodeLength: 'Verification code is 4 digits',
      enterVerificationCode: 'Please enter 4-digit verification code from email',
      sendVerificationCode: 'Send verification code',
      resendVerificationCodeButton: 'Resend verification code',
      completeRegistration: 'Complete registration',
      userLoginRegister: 'User Login/Register',
      login: 'Login',
      register: 'Register',
      name: 'Name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      invitationCodeInvalid: 'Invalid invitation code, please check and re-enter',
      registerSuccessPleaseLogin: 'Registration successful! Please login'
    },
    invitation: {
      myInvitationCode: 'My Invitation Code',
      invitationCode: 'Invitation Code',
      copyInvitationCode: 'Copy Invitation Code',
      invitationCodeCopied: 'Invitation code copied to clipboard',
      copyFailed: 'Copy failed',
      fetchFailed: 'Failed to fetch invitation code',
      shareInvitationCode: 'Share this invitation code with friends. After friends register with this code:\n• Friends will receive coupons on first purchase\n• You will receive coupons for every friend\'s purchase',
      close: 'Close',
      invitationCodePlaceholder: 'Please enter 4-digit invitation code (optional)',
      invitationCodeLength: 'Invitation code is 4 digits',
      inviter: 'Inviter',
      inviteFriendsHint: 'Invite friends to get coupons'
    },
    coupon: {
      title: 'Coupon Selection',
      loginRequired: 'Please login first',
      noAvailable: 'No available coupons',
      fetchFailed: 'Failed to fetch coupons',
      stackable: 'Stackable',
      noDescription: 'No description',
      daysLeft: '{{days}} days left',
      selectedCount: 'Selected {{count}} coupons, total discount:',
      source: {
        referralFirst: 'Referral First Purchase',
        referralRegular: 'Referral Purchase',
        adminGrant: 'Admin Grant',
        systemReward: 'System Reward',
        registration: 'Registration Reward',
        manual: 'Manual Grant',
        unknown: 'Unknown Source'
      },
      statusAbnormal: 'Coupon status abnormal',
      used: 'Used',
      expired: 'Expired',
      availableTotal: 'Available Coupon Total',
      totalAmount: 'Total Coupon Amount',
      noData: 'No coupon data',
      earnMethod: 'You can earn coupons through referrals, system rewards, etc.',
      viewedAll: 'All new coupons have been viewed',
      notAvailable: 'This coupon is not available. It may be expired or already used',
      noExpiry: 'No expiry',
      minimumAmount: 'Minimum purchase: {{amount}}',
      minimumAmountNotMet: 'Order amount must be at least {{amount}} to use this coupon',
      modal: {
        title: 'Congratulations! You have new coupons',
        progress: 'Coupon {current} of {total}',
        defaultDescription: 'Coupon',
        sourceLabel: 'Source',
        expireLabel: 'Valid Until',
        next: 'Next Coupon',
        done: 'Got It',
        remaining: 'You still have {count} coupons to view'
      }
    },
    contact: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message Content',
      notProvided: 'Not provided',
      contactConsultation: 'Contact Consultation',
      form: {
        loginRequired: 'Please login first',
        submitSuccess: 'Your message has been sent successfully, we will reply to you as soon as possible',
        submitFailed: 'Send failed, please try again later'
      }
    },
    orders: {
      loadFailed: 'Failed to load orders',
      loadDetailFailed: 'Failed to load order details',
      cancelConfirmTitle: 'Confirm cancellation',
      cancelConfirmContent: 'Are you sure you want to cancel this order?',
      cancelSuccess: 'Order cancelled',
      cancelFailed: 'Failed to cancel order',
      cancelReason: 'Cancelled by user',
      searchPlaceholder: 'Search order number or address...',
      filterStatusPlaceholder: 'Filter Status',
      page: {
        title: 'Order Management',
        subtitle: 'View and manage all of your orders'
      },
      actions: {
        refresh: 'Refresh Data',
        reset: 'Reset',
        view: 'View',
        writeReview: 'Write Review',
        shareExperience: 'Share Experience'
      },
      list: {
        title: 'Order List',
        summary: 'Total {count} orders',
        empty: 'No order data yet'
      },
      socialShare: {
        submitSuccess: 'Share record submitted successfully! Exclusive coupons will be issued after approval',
        submitFailed: 'Submission failed, please try again',
        platformLabel: 'Social Media Platform',
        platformRequired: 'Please select a social media platform',
        platformPlaceholder: 'Please select your sharing platform',
        linkLabel: 'Share Link',
        linkRequired: 'Please enter share link',
        linkInvalid: 'Please enter a valid link address',
        linkPlaceholder: 'Please paste your share link, e.g.: https://...',
        descriptionLabel: 'Share Description (Optional)',
        descriptionPlaceholder: 'Please briefly describe your experience, this will help us better review...',
        status: {
          pending: 'Pending Review',
          approved: 'Approved',
          couponSent: 'Coupon Sent',
          rejected: 'Rejected'
        }
      },
      review: {
        title: 'Write Product Review',
        congratulations: '🎉 Congratulations on successful delivery!',
        helpOthers: 'Please review your products to help other users!',
        updateHint: 'Note: If you have already reviewed this product, submitting a new review will replace your previous review',
        reviewUpdated: 'Review updated, pending approval',
        loadedExisting: 'Your previous review has been loaded, you can modify and resubmit',
        progressInfo: '📦 Your order has {total} products, currently reviewing product {current}',
        reviewed: 'Reviewed',
        current: 'Current',
        notReviewed: 'Not Reviewed',
        reviewedCount: 'Reviewed {reviewed} / {total}',
        currentProduct: '📝 Current Product:',
        product: 'Product',
        noProducts: 'Order has no products, cannot submit review',
        productNotFound: 'Product information not found',
        invalidOrderId: 'Invalid order ID, cannot submit review',
        invalidProductId: 'Invalid product ID',
        ratingRequired: 'Please select a rating',
        noUserInfo: 'Unable to get user information, please login again',
        submitSuccess: 'Review submitted successfully',
        submitSuccessWithCount: 'Successfully submitted {count} reviews, pending approval',
        submitFailed: 'Review submission failed, please try again',
        switchedToNext: 'Switched to product {next}',
        allReviewsCompleted: 'All product reviews completed!',
        skippedToNext: 'Skipped, switched to product {next}',
        allCompleted: 'Completed browsing all products!',
        previousProduct: 'Previous Product',
        skipProduct: 'Skip This Product',
        reviewLater: 'Review Later',
        submitReview: 'Submit Review',
        ratingLabel: 'Rating',
        titleLabel: 'Review Title',
        titlePlaceholder: 'Give your review a title (optional)',
        contentLabel: 'Review Content',
        contentRequired: 'Please enter review content',
        contentPlaceholder: 'Please share your experience...',
        anonymous: 'Anonymous Review'
      },
      confirmDelivery: {
        title: 'Confirm Delivery',
        content: 'Please confirm that you have received the goods. This action cannot be undone.',
        okText: 'Confirm Delivery',
        button: 'Confirm Delivery',
        notes: 'User confirmed delivery',
        success: 'Delivery confirmed successfully',
        failed: 'Failed to confirm delivery'
      },
      status: {
        pending: 'Pending',
        confirmed: 'Confirmed',
        processing: 'Processing',
        shipped: 'Shipped',
        delivered: 'Delivered',
        cancelled: 'Cancelled',
        refunded: 'Refunded'
      },
      table: {
        orderNumber: 'Order Number',
        status: 'Status',
        totalAmount: 'Total Amount',
        itemCount: 'Item Count',
        shippingAddress: 'Shipping Address',
        createdAt: 'Created At',
        actions: 'Actions',
        view: 'View'
      },
      details: {
        orderNumber: 'Order Number',
        orderStatus: 'Order Status',
        totalAmount: 'Total Amount',
        shippingAddress: 'Shipping Address',
        notes: 'Notes',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
        productList: 'Product List',
        originalPrice: 'Original Price',
        discount: 'Discount',
        total: 'Total',
        noData: 'No data available',
        noNotes: 'None',
        productId: 'Product ID',
        productName: 'Product Name',
        quantity: 'Quantity',
        unitPrice: 'Unit Price',
        subtotal: 'Subtotal'
      },
      shipping: {
        title: 'Shipping Information',
        loading: 'Loading shipping information...',
        trackingNumber: 'Tracking Number',
        carrier: 'Carrier',
        status: 'Shipping Status',
        shippedAt: 'Shipped At',
        deliveredAt: 'Delivered At',
        deliveryAddress: 'Delivery Address',
        contactPhone: 'Contact Phone',
        contactName: 'Contact Name',
        shippingNotes: 'Shipping Notes',
        delivered: 'Delivered',
        inTransit: 'In Transit',
        noData: 'No shipping information available'
      }
    },
    logistics: {
      loadFailed: 'Failed to load logistics information',
      enterTrackingNumber: 'Please enter tracking number',
      queryFailed: 'Query failed, please check the tracking number'
    },
    checkout: {
      cartEmpty: 'Cart is empty',
      createdSuccess: 'Order created successfully',
      createdFailed: 'Failed to create order',
      createdSuccessWithInfo: 'Order created successfully! Our courier will contact you within 1-3 business days to arrange delivery.',
      createdFailedRetry: 'Failed to create order, please try again',
      title: 'Checkout',
      shippingInfo: 'Shipping Information',
      shippingAddress: 'Shipping Address',
      shippingAddressRequired: 'Please enter shipping address',
      shippingAddressPlaceholder: 'Please enter detailed shipping address',
      contactPhone: 'Contact Phone',
      contactPhoneRequired: 'Please enter contact phone',
      contactPhonePlaceholder: 'Please enter contact phone',
      notes: 'Notes',
      notesPlaceholder: 'Special requirements, please note here (optional)',
      subtotal: 'Subtotal',
      couponDiscount: 'Coupon Discount',
      total: 'Total Amount',
      couponValidationFailed: 'Coupon validation failed, please select another coupon',
      paymentMethod: 'Payment Method',
      cod: 'Cash on Delivery',
      deliveryNote: 'Delivery Instructions',
      deliveryDescription: 'Delivery personnel will contact you within 1-3 business days and arrange delivery, please keep your phone available',
      cancel: 'Cancel Order',
      confirm: 'Confirm Order',
      confirmCancel: 'Confirm Cancel',
      cancelConfirmation: 'Are you sure you want to cancel the order? Cancelling will close the checkout window',
      continueOrder: 'Continue Order',
      orderCancelled: 'Order cancelled',
      steps: {
        confirmProducts: 'Confirm Products',
        fillInfo: 'Fill Information',
        payment: 'Payment'
      },
      confirmProducts: {
        title: 'Confirm Products',
        quantity: 'Quantity',
        total: 'Total',
        nextStep: 'Next Step'
      },
      fillInfo: {
        title: 'Fill Shipping Information',
        address: 'Shipping Address',
        addressPlaceholder: 'Please enter detailed shipping address',
        addressRequired: 'Please enter shipping address',
        notes: 'Notes',
        notesPlaceholder: 'Order notes (optional)',
        previousStep: 'Previous Step',
        nextStep: 'Next Step'
      },
      payment: {
        title: 'Payment Method',
        orderCreated: 'Order created, please select payment method',
        paymentPending: 'Payment integration pending',
        payNow: 'Pay Now'
      }
    },
    config: {
      saveSuccess: 'Configuration saved successfully',
      saveFailed: 'Failed to save configuration',
      reset: 'Configuration reset',
      validateSuccess: 'Configuration validated successfully',
      validateFailed: 'Configuration validation failed'
    },
    address: {
      selectRequired: 'Please select a shipping address',
      addSuccess: 'Shipping address added successfully',
      updateSuccess: 'Shipping address updated successfully',
      deleteSuccess: 'Shipping address deleted successfully',
      setDefaultSuccess: 'Default address set successfully'
    },
    products: {
      loadFailed: 'Failed to load product data'
    }
  },

  couponManagement: {
    title: 'My Coupons',
    loginRequired: 'Please login to view coupons',
    messages: {
      fetchFailed: 'Failed to fetch coupon data'
    },
    actions: {
      refresh: 'Refresh'
    },
    stats: {
      activeTotal: 'Available Coupon Total',
      totalAmount: 'Total Coupon Amount',
      expiringSoon: 'Coupons Expiring Soon',
      couponUnit: ' coupons'
    },
    list: {
      title: 'Coupon List',
      loading: 'Loading...',
      empty: 'No coupons yet'
    },
    status: {
      used: 'Used',
      expired: 'Expired',
      expiringSoon: 'Expiring Soon',
      available: 'Available'
    },
    fields: {
      expiresAt: 'Expiration',
      daysLeft: '{days} days remaining',
      usedAt: 'Used at',
      id: 'ID: {id}'
    },
    expiring: {
      title: 'Expiring Coupon Reminder',
      description: 'You have {count} coupons expiring within 7 days. Please use them soon!'
    }
  },

  logistics: {
    title: 'Logistics Tracking',
    trackByNumber: {
      placeholder: 'Please enter tracking number',
      button: 'Search'
    },
    list: {
      title: 'My Deliveries',
      searchPlaceholder: 'Search deliveries...',
      refresh: 'Refresh',
      trackingNumberLabel: 'Tracking No.',
      carrierLabel: 'Carrier',
      createdAtLabel: 'Created At'
    },
    detail: {
      title: 'Delivery Details',
      labels: {
        trackingNumber: 'Tracking No.',
        carrier: 'Carrier',
        status: 'Status',
        estimatedDelivery: 'Estimated Delivery',
        actualDelivery: 'Actual Delivery',
        pickupTime: 'Pickup Time',
        notes: 'Notes'
      },
      values: {
        valueNotSet: 'Not set',
        notDelivered: 'Not delivered',
        notPickedUp: 'Not picked up',
        none: 'None'
      }
    }
  },

  // Navigation
  nav: {
    brand: 'Ventosano',
    home: 'Home',
    about: 'About Us',
    products: 'Products',
    usage: 'Usage',
    classroom: 'Health Classroom',
    symptoms: 'Symptoms',
    shoppingGuide: 'Shopping Guide',
    contact: 'Contact Us',
    login: 'Login',
    myAccount: 'My Account',
    productCatalog: 'Product Catalog',
    myOrders: 'My Orders',
    myCoupons: 'My Coupons',
    myInvitationCode: 'My Invitation Code',
    logisticsTracking: 'Logistics Tracking',
    customerService: 'Customer Service',
    logout: 'Logout',
    shoppingCart: 'Shopping Cart'
  },

  // Shopping Cart
  cart: {
    title: 'Shopping Cart',
    empty: 'Shopping cart is empty',
    removeItem: 'Item removed from cart',
    clearCart: 'Cart cleared',
    checkout: 'Checkout',
    total: 'Total',
    quantity: 'Quantity',
    remove: 'Remove',
    clear: 'Clear Cart',
    continueShopping: 'Continue Shopping',
    stock: 'Stock',
    subtotal: 'Subtotal',
    useCoupon: 'Use Coupon',
    selectItemsWarning: 'Please select items to purchase',
    orderCreatedSuccess: 'Order created successfully!',
    selectAll: 'Select All',
    selectedItems: 'Selected {selected} / {total} items',
    selectedTotalPrice: 'Selected Items Total',
    couponDiscount: 'Coupon Discount',
    payableAmount: 'Payable Amount',
    items: ' items',
    discounted: 'Discounted',
    addToCartSuccess: 'Added {name} to cart'
  },

  // Homepage
  home: {
    hero: {
      title: 'Breathe Freely, Start Today',
      slogan: 'Say goodbye to nasal congestion\nEmbrace clear breathing',
      description1: 'Professional nasal rinsing technology gently cleanses your nasal cavity for comfortable breathing every day',
      description2: 'Scientific care philosophy awakens your nasal cavity\'s natural defense mechanisms, protecting your respiratory health',
      viewProducts: 'Experience Now',
      consultNow: 'Expert Consultation'
    },
        carousel: {
          slide1: {
            title: 'Nashuchun Nasal Irrigator\nYour Nasal Health Guardian',
            description: 'Specializing in flexible positive-negative pressure balance nasal irrigator, making nasal rinsing simpler, more comfortable, and more reassuring',
            buttonText: 'Experience Now'
          },
          slide2: {
            title: 'Leave Your Nasal Health to Nashuchun',
            description: 'Years of expertise in nasal irrigators, clearing nasal congestion and restoring free breathing',
            buttonText: 'Learn More'
          },
          slide3: {
            title: 'Flexible & Comfortable / Balanced Pressure & Safe / Say Goodbye to Uncomfortable Rinsing',
            description: 'Professional nasal rinsing technology provides you with a comfortable and safe nasal care experience',
            buttonText: 'Expert Consultation'
          }
        },
    sections: {
      nasalHealth: {
        title: 'Breathing Quality Determines Life Quality',
        description: 'The human body needs to inhale 6-8 liters of air per minute. The nasal cavity is the first gateway for oxygen entry. When nasal health is maintained, we can obtain sufficient oxygen for optimal body function.',
        features: [
          'Clear nasal passages ensure adequate oxygen supply for better energy and focus',
          'Nasal congestion dramatically reduces oxygen intake, leading to fatigue and poor concentration',
          'Chronic breathing difficulties affect sleep quality and work efficiency',
          'Regular nasal care ensures every breath is full of vitality'
        ]
      },
      nasalCare: {
        title: 'Let Nasal Rinsing Become Your Health Care Partner!',
        description: 'Many nasal problems stem from the nasal cavity enduring prolonged excessive stimulation and burden.\nWhen we actively cleanse the nasal cavity daily, washing away accumulated pathogens and irritants, we help the nasal cavity reduce its burden and return to its original balanced state.\nNasal rinsing is not just cleansing; it\'s a gentle ritual to awaken the nasal cavity\'s self-healing power. Through gentle irrigation, we restore the defensive function of the nasal mucosa, strengthen the buffer against external pollution, and restore respiratory stability and health.\nWe firmly believe: true care follows the body\'s inherent wisdom, allowing it to naturally exert its protective power.\nMedication is not necessarily the only choice for nasal problems.\nLet "nasal rinsing" become your health care partner, accompanying you every day, gently guarding the purity and freedom of your breath.',
        learnMore: 'Learn More About Nasal Care→'
      },
      lifestyle: {
        title: 'Nasal Rinsing: A Respiratory Revolution for Modern Life',
        description: 'As natural as brushing teeth and washing face, nasal rinsing has become an essential health habit for modern people. Just a few minutes of daily nasal care not only prevents diseases but brings the joy of fresh breathing.',
        features: [
          { title: 'Prevent Respiratory Diseases', desc: 'Clear allergens and reduce infection risks' },
          { title: 'Improve Sleep Quality', desc: 'Clear breathing for restful sleep' },
          { title: 'Boost Mental Clarity', desc: 'Adequate oxygen for sharper thinking' },
          { title: 'Strengthen Immunity', desc: 'Healthy protection for stronger body' }
        ],
        learnMore: 'Learn More',
        experienceNow: 'Start Experience'
      },
      analysis: {
        title: 'Traditional Nasal Rinsing Woes - We Understand',
        description: 'Many people know nasal rinsing is beneficial, but traditional nasal rinsers create barriers with choking, pain, and complexity... turning health care into a burden.',
        stats: [
          { number: '75%', label: 'Fear Choking Discomfort' },
          { number: '68%', label: 'Worry About Pain' },
          { number: '42%', label: 'Find It Complicated' },
          { number: '70%', label: 'Fear Infections' }
        ]
      },
      products: {
        title: 'Ventosano Best-Selling Products',
        subtitle: 'Carefully selected high-quality products to protect your nasal health',
        buttons: {
          buyNow: 'Buy Now'
        },
        badges: {
          hot: 'Hot',
          new: 'New',
          essential: 'Essential',
          accessory: 'Accessory'
        },
        items: {
          gen1: {
            name: 'Ventosano 1st Gen Nasal Irrigator',
            alt: 'Ventosano 1st Gen Nasal Irrigator'
          },
          gen2: {
            name: 'Ventosano 2nd Gen Nasal Irrigator',
            alt: 'Ventosano 2nd Gen Nasal Irrigator'
          },
          salt: {
            name: 'Ventosano Saline Solution',
            alt: 'Ventosano Saline Solution'
          },
          tip: {
            name: 'Ventosano Therapeutic Nasal Tip',
            alt: 'Ventosano Therapeutic Nasal Tip'
          }
        }
      },
      services: {
        title: 'Our Service Commitments',
        subtitle: 'Providing you with the highest quality products and service experience',
        items: {
          shipping: {
            title: '24h Fast Shipping',
            description: 'Year-round service, fastest next-day delivery'
          },
          freeShipping: {
            title: 'Free Shipping over $500',
            description: 'Free shipping for all orders over $500'
          },
          quality: {
            title: 'Quality Assurance',
            description: 'SGS/QMS/RoHS triple certification'
          }
        }
      },
      whyChoose: {
        title: 'Choose Ventosano, Choose Better Breathing',
        subtitle: 'Breaking traditional limitations, redefining nasal care experience',
        features: [
          { title: 'Innovative Balanced Pressure Technology', desc: 'Patent design eliminates choking concerns, gentle and comfortable like a massage', badge: 'Exclusive Patent' },
          { title: 'Medical-Grade Nasal Tip', desc: 'Precision manufacturing for deep cleaning, making every care session more effective', badge: 'Medical Certified' },
          { title: 'Safety Quality Assurance', desc: 'International certifications for peace of mind, protecting your health journey', badge: 'International Certified' }
        ],
        buttons: {
          buyNow: 'Buy Now'
        }
      },
      userTestimonials: {
        title: 'User Testimonials'
      },
      video: {
        text: 'Watch Product Introduction Video',
        note: 'Learn how to use Ventosano nasal rinse'
      },
      images: {
        nasalHealth: 'Nasal Health Image',
        nasalCare: 'Nasal Care Image',
        lifestyle: 'Lifestyle Image',
        analysis: 'Analysis Image',
        user: 'User Avatar'
      }
    },
    stats: {
      satisfied: 'Satisfied Users',
      satisfiedDesc: 'Satisfied Users',
      recommendation: 'Recommendation Rate',
      recommendationDesc: 'Recommendation Rate',
      rating: 'User Rating',
      ratingDesc: 'User Rating',
      support: 'Customer Support',
      supportDesc: '24/7 Service'
    }
  },

  // Health Classroom
  classroom: {
    title: 'Ventosano Health Classroom',
    subtitle: 'Comfortable Nasal Rinsing, Caring for Your Nasal Cavity Every Day',
    description: 'Professional nasal health knowledge base to make you a nasal rinsing expert',
    sectionTitle: 'Nasal Health',
    readMore: 'Read Full Article',
    backToList: 'Back to Article List',
    articles: {
      covid: {
        title: 'COVID-19 Nasal Rinsing: Scientifically Proven Anti-Epidemic Method',
        badge: 'COVID-19 Prevention',
        subtitle: 'Foreign COVID-19 human experiments confirm that nasal rinsing can effectively improve confirmed symptoms!',
        content: `
          <p class="lead">COVID-19 is primarily transmitted through the respiratory tract, and the nasal cavity is an important gateway for the virus to enter the human body. Scientific nasal rinsing methods can effectively remove viruses from the nasal cavity, reduce infection risk, and serve as an important auxiliary measure for COVID-19 prevention.</p>
          
          <h2>Relationship Between COVID-19 and Nasal Cavity</h2>
          <p>COVID-19 primarily enters human cells through ACE2 receptors, and the nasal mucosa is rich in ACE2 receptors, making it the main site of viral infection. After the virus replicates in the nasal cavity, it spreads downward through the respiratory tract, causing systemic infection.</p>
          
          <div class="highlight-box">
            <h4>Important Reminder</h4>
            <p class="mb-0">Nasal rinsing is an auxiliary method for COVID-19 prevention and cannot replace main preventive measures such as vaccination, wearing masks, and maintaining social distance.</p>
          </div>
          
          <h2>Mechanism of Nasal Rinsing for COVID-19 Prevention</h2>
          <h3>1. Physical Virus Removal</h3>
          <p>Nasal rinsing can effectively remove virus particles attached to the nasal mucosa through physical flushing, reducing viral load and lowering infection risk.</p>
          
          <h3>2. Diluting Virus Concentration</h3>
          <p>Physiological saline rinsing can dilute the virus concentration in the nasal cavity, reducing the virus's ability to attach to the mucosa and decreasing infection opportunities.</p>
          
          <h3>3. Enhancing Mucosal Protection</h3>
          <p>Regular nasal rinsing can keep the nasal cavity moist, enhance the self-protection ability of the mucosa, and improve resistance to viruses.</p>
          
          <h2>Scientific Research Evidence</h2>
          <p>Multiple international studies show that nasal irrigation has significant protective and therapeutic effects against COVID-19:</p>
          <ul>
            <li>UK research found that nasal irrigation can reduce COVID-19 infection risk by 62%</li>
            <li>US research confirmed that nasal rinsing can shorten COVID-19 course by 2-3 days</li>
            <li>German research showed that nasal rinsing can reduce severe cases by 40%</li>
          </ul>
          
          <h2>Correct Nasal Rinsing Method</h2>
          <h3>1. Choose Appropriate Nasal Irrigator</h3>
          <p>We recommend using negative pressure nasal irrigators, such as Ventosano nasal irrigator, which are safe and gentle, suitable for daily use.</p>
          
          <h3>2. Prepare Physiological Saline</h3>
          <p>Use 0.9% physiological saline with temperature controlled at 35-37°C, close to body temperature.</p>
          
          <h3>3. Correct Nasal Rinsing Posture</h3>
          <p>Tilt your head forward 45 degrees, gently insert the nasal tip into one nostril, and let the saline flow out from the other nostril.</p>
          
          <h3>4. Nasal Rinsing Frequency</h3>
          <p>It is recommended to rinse the nose 1-2 times daily, 5-10 minutes each time, with better effects through continuous use.</p>
          
          <h2>Precautions</h2>
          <ul>
            <li>Thoroughly clean hands before and after nasal rinsing</li>
            <li>Use dedicated nasal rinsing salt, avoid using ordinary table salt</li>
            <li>Thoroughly clean the nasal irrigator after use</li>
            <li>Stop immediately and consult a doctor if discomfort occurs</li>
          </ul>
          
          <h2>Conclusion</h2>
          <p>As an auxiliary method for COVID-19 prevention, nasal rinsing has the characteristics of being safe, effective, and economical. Through scientific nasal rinsing methods combined with other preventive measures, infection risk can be effectively reduced, protecting the health of yourself and your family.</p>
        `
      },
      cold: {
        title: 'Cold Nasal Rinsing: Natural Therapy for Quick Relief of Nasal Congestion',
        badge: 'Cold Treatment',
        subtitle: 'Suffering from nasal congestion during colds? Nasal rinsing is a natural and effective method to relieve cold symptoms!',
        content: '<p class="lead">Cold is one of the most common diseases in daily life, and symptoms such as nasal congestion and runny nose seriously affect quality of life. Nasal rinsing, as a natural, safe, and effective auxiliary therapy, is receiving increasing attention.</p><h2>Scientific Principles of Cold Nasal Rinsing</h2><p>During colds, viruses stimulate the nasal mucosa, leading to increased nasal secretions and causing symptoms such as nasal congestion and runny nose. Nasal rinsing can:</p><ul><li>Remove viruses and bacteria from the nasal cavity</li><li>Reduce nasal congestion and inflammation</li><li>Relieve symptoms and speed up recovery</li></ul><h2>Conclusion</h2><p>As an auxiliary method for cold treatment, nasal rinsing has the characteristics of being safe, effective, and economical. Through scientific nasal rinsing methods combined with other treatment measures, cold symptoms can be effectively relieved and recovery accelerated.</p>'
      },
      rhinitis: {
        title: 'Rhinitis Nasal Rinsing: Fundamentally Improve Nasal Health',
        badge: 'Rhinitis Treatment',
        subtitle: 'Chronic rhinitis troubling your life? Nasal rinsing is an important auxiliary method for treating rhinitis!',
        content: '<p class="lead">Chronic rhinitis troubling your life? Nasal rinsing is an important auxiliary method for treating rhinitis! This article details the therapeutic effects of nasal rinsing on various types of rhinitis, helping you regain clear breathing.</p><h2>Classification and Symptoms of Rhinitis</h2><p>Rhinitis is mainly divided into allergic rhinitis, infectious rhinitis, and vasomotor rhinitis. Common symptoms include nasal congestion, runny nose, sneezing, and nasal itching, which seriously affect quality of life and sleep quality.</p><h2>Conclusion</h2><p>As an auxiliary method for rhinitis treatment, nasal rinsing has the characteristics of being safe, effective, and economical. Through scientific nasal rinsing methods combined with other treatment measures, rhinitis symptoms can be effectively improved and quality of life enhanced.</p>'
      },
      allergicRhinitis: {
        title: 'Allergic Rhinitis and Symptoms: Comprehensive Analysis and Treatment Solutions',
        badge: 'Allergic Rhinitis',
        subtitle: 'Allergic rhinitis is really uncomfortable! Every 3 people in Taiwan, 1 has nasal allergies.',
        content: '<p class="lead">Allergic rhinitis is one of the most common allergic diseases in modern society, affecting the quality of life of hundreds of millions of people worldwide. This article will provide you with a comprehensive guide to allergic rhinitis from causes, symptoms, diagnosis to treatment.</p><h2>What is Allergic Rhinitis</h2><p>Allergic rhinitis is an inflammatory disease of the nasal mucosa caused by allergens, mainly manifested as nasal congestion, runny nose, sneezing, and nasal itching. When allergens enter the nasal cavity, they stimulate the immune system to produce allergic reactions.</p><h2>Conclusion</h2><p>Although allergic rhinitis is troublesome, symptoms can be effectively controlled and quality of life improved through scientific treatment and care.</p>'
      },
      rhinitisSinusitisDifference: {
        title: 'The Difference Between Rhinitis and Sinusitis: Symptoms, Treatment and Prevention',
        badge: 'Disease Differentiation',
        subtitle: 'Rhinitis and sinusitis are often confused, but their symptoms and treatment methods are very different!',
        content: '<p class="lead">Rhinitis and sinusitis are two common nasal diseases. Although the symptoms are similar, the causes and treatment methods are different. Correctly distinguishing between these two diseases helps in choosing appropriate treatment plans.</p><h2>Definition of Rhinitis and Sinusitis</h2><h3>Rhinitis</h3><p>Rhinitis refers to inflammation of the nasal mucosa, mainly affecting the inside of the nasal cavity, with relatively mild symptoms.</p><h3>Sinusitis</h3><p>Sinusitis refers to inflammation of the sinus mucosa, which can cause more severe symptoms and complications.</p><h2>Conclusion</h2><p>Correctly distinguishing between rhinitis and sinusitis is crucial for choosing appropriate treatment methods. If in doubt, it is recommended to seek medical diagnosis in time.</p>'
      },
      rhinitisMedicationGuide: {
        title: 'Common Rhinitis Medications: Types, Effects and Precautions',
        badge: 'Drug Treatment',
        subtitle: 'Facing a dazzling array of rhinitis medications, do you know how to choose?',
        content: '<p class="lead">Drug treatment is an important component of rhinitis treatment. Correct medication methods can improve efficacy and reduce side effects. This article will introduce commonly used rhinitis drugs and their usage methods.</p><h2>Common Drug Classifications</h2><h3>1. Antihistamines</h3><p>Antihistamines are the first-choice drugs for treating allergic rhinitis, which can quickly relieve symptoms such as sneezing, runny nose, and nasal itching.</p><h2>Conclusion</h2><p>Drug treatment needs to be combined with other treatment methods. Only with scientific medication under doctor\'s guidance can the best therapeutic effect be achieved.</p>'
      },
      nasalIrrigatorSelectionGuide: {
        title: 'Nasal Irrigator Classification and Selection: How to Choose the Most Suitable Nasal Irrigator',
        badge: 'Equipment Selection',
        subtitle: 'There are many types of nasal irrigators on the market, with different characteristics of positive pressure, negative pressure, and balanced pressure!',
        content: '<p class="lead">There are many types of nasal irrigators on the market. How to choose the right nasal irrigator for yourself? This article will provide professional purchasing advice from multiple dimensions such as working principles, rinsing methods, and power types.</p><h2>Core Classification Dimensions of Nasal Irrigators</h2><h3>1. Classification by Working Principle</h3><ul><li>Positive pressure nasal irrigator</li><li>Negative pressure nasal irrigator</li><li>Balanced pressure nasal irrigator</li></ul><h2>Conclusion</h2><p>When choosing a nasal irrigator, safety should be the top priority. Negative pressure is safer than positive pressure, spray type is gentler than water column type, and manual type is more cost-effective than electric type.</p>'
      },
      salineSolutionGuide: {
        title: 'Choosing Nasal Salts: Comparison of Professional Formulas and Commercial Products',
        badge: 'Nasal Washing Products',
        subtitle: 'Nasal salts are the key to comfortable nasal washing! Professional formulas and commercial products each have their own characteristics',
        content: '<p class="lead">Physiological saline is the basic product for nasal rinsing. The correct selection and use method directly affects the effect and safety of nasal rinsing. This article will introduce in detail the selection, use, and precautions of physiological saline.</p><h2>What is Physiological Saline</h2><p>Physiological saline refers to a 0.9% sodium chloride solution, whose osmotic pressure is the same as human plasma and will not cause irritation or damage to the nasal mucosa.</p><h2>Conclusion</h2><p>Correctly choosing and using physiological saline is the foundation of safe nasal rinsing. Through scientific methods, the effectiveness and safety of nasal rinsing can be ensured.</p>'
      },
      allergicRhinitisCare: {
        title: 'Daily Care Guide for Allergic Rhinitis',
        badge: 'Daily Care',
        subtitle: 'Although allergic rhinitis cannot be completely cured, correct daily care can effectively control symptoms',
        content: '<p class="lead">Although allergic rhinitis cannot be completely cured, symptoms can be effectively controlled and quality of life improved through scientific daily care. This article will introduce practical care methods.</p><h2>Environmental Control</h2><h3>1. Indoor Environment</h3><ul><li>Keep indoor air clean and ventilated</li><li>Use air purifiers to filter allergens</li><li>Regularly clean and reduce dust mites</li></ul><h2>Conclusion</h2><p>Daily care for allergic rhinitis requires long-term persistence. Through comprehensive measures, symptoms can be effectively improved and better quality of life enjoyed.</p>'
      },
      sinusitisPreventionTreatment: {
        title: 'Sinusitis Prevention and Treatment Guide',
        badge: 'Sinusitis',
        subtitle: 'Sinusitis is inflammation of the bony cavities around the nasal cavity, common symptoms include nasal congestion, headache, facial tenderness, etc.',
        content: '<p class="lead">Sinusitis is a common nasal disease that not only affects breathing but may also cause headaches and other discomforts. Through scientific prevention and treatment methods, the condition can be effectively controlled and quality of life improved.</p><h2>Prevention of Sinusitis</h2><h3>1. Enhance Immunity</h3><p>Maintain regular work and rest, exercise appropriately, eat a balanced diet, enhance body resistance, and reduce infection opportunities.</p><h2>Conclusion</h2><p>Prevention and treatment of sinusitis need to be considered comprehensively. Early detection and early treatment are key.</p>'
      },
      seasonalRhinitisStrategies: {
        title: 'Seasonal Rhinitis Response Strategies',
        badge: 'Seasonal Care',
        subtitle: 'Seasonal rhinitis usually occurs in specific seasons, such as spring pollen season or autumn grass pollen season',
        content: '<p class="lead">Seasonal rhinitis is a type of allergic rhinitis that usually occurs in specific seasons, such as spring pollen season or autumn grass pollen season. Understanding seasonal patterns and taking corresponding measures can effectively reduce symptoms.</p><h2>Seasonal Rhinitis Attack Patterns</h2><p>Different seasons have different allergens: spring is mainly tree pollen, summer is grass pollen, autumn is weed pollen, and winter is mainly indoor allergens such as dust mites and pet hair.</p><h2>Conclusion</h2><p>Although seasonal rhinitis is troublesome, symptoms can be effectively controlled by understanding seasonal patterns and taking corresponding measures. Remember, prevention is better than cure, and advance preparation is key.</p>'
      },
      childrenNasalCareGuide: {
        title: 'Children Nasal Care Guide',
        badge: 'Children Care',
        subtitle: 'Children\'s nasal development is not yet fully mature, their resistance is relatively weak, and they are prone to various nasal problems',
        content: '<p class="lead">Children\'s nasal development is not yet fully mature, and their resistance is relatively weak, making them prone to various nasal problems. Correct care methods can not only prevent diseases but also promote healthy nasal development.</p><h2>Characteristics of Children\'s Nasal Cavity</h2><p>Compared with adults, children\'s nasal cavity has the following characteristics:</p><ul><li>Narrower nasal passages</li><li>More sensitive mucosa</li><li>Weaker immune system</li></ul><h2>Conclusion</h2><p>Children\'s nasal care requires special attention and careful care. Through scientific methods and parental supervision, diseases can be effectively prevented and healthy nasal development promoted.</p>'
      }
    },

    // Pagination display text
    pagination: {
      showTotal: 'Items {start}-{end} of {total}'
    }
  },

  // Forms
  forms: {
    contact: {
      title: 'Consult Now',
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      company: 'Company Name',
      message: 'Inquiry Content',
      cooperation: 'Cooperation Intent',
      options: {
        retail: 'Retail',
        wholesale: 'Wholesale',
        odm: 'Design & Manufacturing',
        oem: 'OEM Manufacturing'
      },
      submit: 'Submit Inquiry',
      success: 'Thank you for your inquiry! We will contact you soon.'
    },

    // HomePage Contact Form
    homeContact: {
      title: 'Consult Now',
      name: {
        label: 'Name',
        placeholder: 'Please enter your name'
      },
      phone: {
        label: 'Phone',
        placeholder: 'Please enter your phone'
      },
      email: {
        label: 'Email',
        placeholder: 'Please enter your email'
      },
      company: {
        label: 'Company Name',
        placeholder: 'Please enter company name'
      },
      message: {
        label: 'Inquiry Content',
        placeholder: 'Please enter inquiry content'
      },
      cooperation: {
        label: 'Cooperation Intent',
        placeholder: 'Please select',
        retail: 'Retail',
        wholesale: 'Wholesale',
        odm: 'Design & Manufacturing',
        oem: 'OEM Manufacturing'
      },
      submit: 'Submit Inquiry',
      success: 'Thank you for your inquiry! We will contact you soon.'
    }
  },



  // About Us page
  about: {
    title: 'About Us',
    subtitle: 'Dedicated to nasal health, committed to providing the highest quality nasal care solutions for users worldwide.',
    businessCooperation: {
      title: 'Business Cooperation',
      description: 'Brand agency, channel partnership, OEM/ODM welcome to discuss',
      retail: {
        title: 'Retail',
        subtitle: 'Promotion',
        features: [
          'Online Store',
          'Online Store',
          'Social Media',
          'Private Domain'
        ]
      },
      wholesale: {
        title: 'Wholesale',
        subtitle: 'Distribution',
        features: [
          'Our Patents',
          'Our Products',
          'Our Brand',
          'Your Market'
        ]
      },
      designManufacturing: {
        title: 'Design & Manufacturing',
        subtitle: 'Design',
        features: [
          'Our Patents',
          'New Appearance',
          'Your Brand',
          'Your Market'
        ]
      },
      oem: {
        title: 'OEM Manufacturing',
        subtitle: 'Production',
        features: [
          'Our Patents',
          'Our Factory',
          'Our Brand',
          'Your Market'
        ]
      }
    },
    certifications: {
      title: 'Complete Guarantee Qualifications',
      subtitle: 'We have officially certified product qualifications and production process qualifications, and have obtained US CQC safety certification and EU RSL certification.'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Welcome to contact us to learn more about cooperation opportunities and product information',
      email: {
        title: 'Email',
        address: 'info@ventosano.com',
        response: 'Reply within 24 hours'
      },
      phone: {
        title: 'Phone Contact',
        number: '+886 2 1234 5678',
        hours: 'Monday to Friday 9:00-18:00'
      },
      address: {
        title: 'Company Address',
        location: '7, Xinyi Rd., Sec. 5, Xinyi Dist., Taipei City',
        building: 'Taipei 101 Building'
      },
      form: {
        title: 'Send Message',
        name: 'Name',
        namePlaceholder: 'Your Name',
        email: 'Email',
        emailPlaceholder: 'Your Email',
        subject: 'Subject',
        subjectPlaceholder: 'Subject',
        message: 'Message Content',
        messagePlaceholder: 'Your Message',
        submit: 'Send Message'
      }
    },
    experience: {
      title: 'Professional Expertise',
      description: 'Ten years of deep expertise in medical device manufacturing, with rich experience in oxygen concentrators, nasal irrigators, nebulizers, and related products'
    },
    manufacturing: {
      title: 'Manufacturing Strength',
      description: 'Modern facility over 8,000 square meters, equipped with advanced production equipment and testing instruments, strictly following medical device production standards'
    },
    innovation: {
      title: 'Technical Innovation',
      description: '6 core patents for balanced pressure nasal irrigators, continuous innovation and R&D, leading industry technological development'
    },
    team: {
      title: 'International Technical Team',
      subtitle: 'Our core technology comes from the core doctoral team at the National University of Singapore',
      singapore: {
        title: 'Singapore Engineers',
        description: 'Precision manufacturing and quality control experts'
      },
      taiwan: {
        title: 'Taiwan Engineers',
        description: 'Nasal cavity fluid dynamics simulation'
      },
      india: {
        title: 'Indian Engineers',
        description: 'Drawing design and 3D printing verification'
      },
      collaboration: 'The collaboration of three major technical teams provides world-class technical support for Ventosano products'
    }
  },


  // Footer
  footer: {
    company: {
      name: 'Ventosano',
      description: 'Focused on the research, development and manufacturing of nasal cleaning equipment, committed to providing users with safe, comfortable and effective nasal cleaning solutions.'
    },
    quickLinks: {
      title: 'Store Information',
      features: 'Features',
      symptoms: 'Symptoms',
      saline: 'Saline',
      vortex: 'Vortex Technology'
    },
    services: {
      title: 'Shopping Guide',
      cooperation: 'Cooperation',
      about: 'About Us',
      contact: 'Contact Us'
    },
    contact: {
      title: 'Contact Information',
      email: 'service@ventosano.com',
      phone: '(02) 7730-8767',
      line: 'LINE: @ventosano'
    },
    newsletter: {
      placeholder: 'Enter email for latest updates'
    },
    legal: {
      copyright: 'Copyright ©2025 Ventosano. All rights reserved.',
      privacy: 'Privacy Policy',
      deleteAccount: 'Delete Account',
      terms: 'Terms of Service',
      sitemap: 'Sitemap'
    }
  },

  // Products
  products: {
    title: 'Products',
    subtitle: 'Caring for Your Nasal Cavity, Starting Simply',
    noProducts: 'No products available',
    hero: {
      title: 'Redefining Nasal Rinsing Experience',
      subtitle: 'Ventosano™ Balanced Pressure Technology',
      description: 'Patent technology, worry-free safety',
      badge: 'Exclusive Patent',
      ctaDescription: 'Breaking traditional nasal rinsing limitations, making nasal care simple, safe, and comfortable',
      ctaButton: 'Learn About "5-Step Nasal Rinsing Method"'
    },
    comparison: {
      title: 'Revolutionary Technology Comparison',
      subtitle: 'Ventosano™ Balanced Pressure Technology surpasses traditional nasal rinsers in every aspect',
      features: {
        safety: 'Safety Level',
        comfort: 'Comfort Level',
        effectiveness: 'Cleaning Effectiveness',
        cleanliness: 'Operation Convenience',
        price: 'Value for Money'
      },
      levels: {
        low: 'Lower',
        medium: 'Moderate',
        high: 'Excellent'
      },
      columns: {
        feature: 'Comparison Items',
        traditionalPositive: 'Traditional Positive Pressure',
        traditionalNegative: 'Traditional Negative Pressure',
        nasopureliefa: 'Ventosano™ Balanced Pressure'
      },
      table: {
        rows: [
          {
            feature: 'Safety',
            traditionalPositive: 'Low',
            traditionalNegative: 'Medium',
            nasopureliefa: 'High'
          },
          {
            feature: 'Comfort',
            traditionalPositive: 'Low',
            traditionalNegative: 'Medium',
            nasopureliefa: 'High'
          },
          {
            feature: 'Cleaning Convenience',
            traditionalPositive: 'Low',
            traditionalNegative: 'Medium',
            nasopureliefa: 'High'
          },
          {
            feature: 'Price',
            traditionalPositive: 'Low',
            traditionalNegative: 'High',
            nasopureliefa: 'Medium'
          }
        ]
      }
    },
    features: {
      title: 'Product Features',
      subtitle: 'Innovative Technology, Professional Quality',
      items: [
        {
          title: 'Safety',
          description: 'The balanced pressure design ensures that the pressure in the nasal cavity remains within the safe range during washing, avoiding damage to the nasal mucosa.',
          icon: 'safety'
        },
        {
          title: 'Comfort',
          description: 'The balanced pressure design ensures that the washing process is gentle and comfortable without discomfort. The water flow is stable and controllable, avoiding the irritation caused by excessive pressure.',
          icon: 'comfort'
        },
        {
          title: 'Effectiveness',
          description: 'Thoroughly cleans the nasal cavity, removes dirt and allergens, and effectively improves nasal ventilation. Regular use can reduce the occurrence of rhinitis and sinusitis.',
          icon: 'effectiveness'
        },
        {
          title: 'Convenience',
          description: 'Simple operation, easy to master. The detachable design makes cleaning and maintenance more convenient. Lightweight and portable, suitable for home and travel use.',
          icon: 'convenience'
        }
      ]
    },
    vortexTip: {
      title: 'Vortex Nasal Tip Technology',
      description: 'Innovative spiral structure design creates vortex water flow that can bypass nasal turbinates to reach various sinus openings and olfactory cleft areas, providing more comprehensive nasal cleaning.',
      features: {
        spiral: {
          title: 'Spiral Structure',
          description: 'The nasal tip adopts a spiral structure design that creates vortex water flow when water is released. The optimal thread structure is found through fluid dynamics simulation.'
        },
        deepClean: {
          title: 'Deep Cleaning',
          description1: 'Vortex water flow can bypass nasal turbinate structures, reach deep into the nasal cavity, and access various sinus openings, effectively cleaning areas that ordinary nasal irrigators cannot reach.',
          description2: 'The olfactory cleft area has slower airflow and is prone to particle deposition, which ordinary nasal irrigators cannot easily clean. The vortex nasal tip can effectively clean this area.'
        },
        precision: {
          title: 'Precision Manufacturing',
          description: 'Precision mold processing ensures that the size and angle of each thread meet design requirements, guaranteeing that water flow can form the target vortex pattern. Secondary vulcanization process ensures silicone material resistance to high temperature, corrosion, and aging.'
        },
        comfort: {
          title: 'High Comfort',
          description: 'Dispersed water flow reduces impact and stinging sensation, minimizing nasal mucosa damage.'
        }
      }
    },
    design: {
      title: 'Product Design Philosophy',
      description1: 'We believe that good product design should return to essence. The Ventosano™ nasal irrigator uses medical-grade materials with transparent design that allows you to clearly see every detail, and one-piece molding process ensures seamless and easy cleaning.',
      description2: 'Simple, but not simple. Every detail is carefully designed to give you the purest nasal care experience.'
    },
    testimonials: {
      title: 'Customer Reviews',
      description: 'Customers generally find the experience excellent, with superior craftsmanship, and are willing to recommend it to friends and family who need nasal care.'
    },
    technology: {
      balancedPressure: {
        title: 'Balanced Pressure Technology'
      }
    },
    images: {
      product: {
        main: 'Main Product',
        design: 'Product Design',
        detail: 'Product Details',
        usage: 'Usage Method',
        showcase: 'Product Showcase',
        tip: 'Nasal Tip'
      },
      testimonials: {
        title: 'Customer Reviews',
        description: 'Real users share their experiences, witnessing the excellent effects of Ventosano nasal irrigator',
        comment1: 'Customer Review 1',
        comment2: 'Customer Review 2',
        comment3: 'Customer Review 3',
        comment4: 'Customer Review 4'
      }
    }
  },

  // Symptoms
  symptoms: {
    title: 'Applicable Symptoms',
    subtitle: 'Ventosano nasal rinse is suitable for various nasal problems',
    commonProblems: {
      title: 'Common Nasal Problems',
      description: 'Ventosano nasal rinse can effectively relieve the following nasal problems',
      items: {
        nasalCongestion: {
          title: 'Nasal Congestion',
          description: 'Blocked nasal passages, difficulty breathing'
        },
        postNasalDrip: {
          title: 'Post-Nasal Drip',
          description: 'Mucus dripping down the throat'
        },
        turbinateHypertrophy: {
          title: 'Turbinate Hypertrophy',
          description: 'Enlarged turbinate tissue'
        },
        deviatedSeptum: {
          title: 'Deviated Septum',
          description: 'Nasal septum deviated from center'
        },
        postSurgicalCare: {
          title: 'Post-Surgical Care',
          description: 'Recovery care after nasal surgery'
        },
        dryRhinitis: {
          title: 'Dry Rhinitis',
          description: 'Dry and inflamed nasal mucosa'
        },
        vasomotorRhinitis: {
          title: 'Vasomotor Rhinitis',
          description: 'Non-allergic rhinitis caused by vascular nerve dysfunction'
        },
        infectiousRhinitis: {
          title: 'Infectious Rhinitis',
          description: 'Caused by bacterial or viral infection'
        },
        eyeNoseAllergy: {
          title: 'Eye-Nose Allergy',
          description: 'Allergic rhinitis with eye symptoms'
        },
        nasalCough: {
          title: 'Nasal Cough',
          description: 'Cough caused by nasal mucus irritation'
        },
        sleepApnea: {
          title: 'Sleep Apnea',
          description: 'Breathing interruption during sleep'
        },
        occupationalRhinitis: {
          title: 'Occupational Rhinitis',
          description: 'Rhinitis caused by work environment'
        }
      }
    }
    ,
    // For single-item sections in SymptomsPage
    flu: {
      title: 'Flu & Cold',
      description: 'Gentle rinsing reduces nasal secretions and blockage, easing flu/cold discomfort'
    },
    covid: {
      title: 'COVID-19 Related',
      description: 'Proper nasal rinsing helps reduce viral load in nasal cavity as an auxiliary measure'
    },
    rhinitis: {
      title: 'Rhinitis',
      description: 'Regular cleansing reduces allergens and mucus, improving congestion and runny nose'
    },
    smog: {
      title: 'Smog / Air Pollution',
      description: 'Removes PM2.5 and particulates, protects mucosa and relieves discomfort'
    }
  },

  // Shopping Guide
  shoppingGuide: {
    title: 'Shopping Guide',
    subtitle: 'Complete shopping process guide to help you easily purchase Ventosano products',
    alerts: {
      importantReminder: 'Important Reminder',
      freeShipping: 'Free Shipping Offer',
      notes: 'Notes',
      returnConditions: 'Return Conditions',
      refundTime: 'Refund Time',
      serviceHours: 'Service Hours'
    },
    returns: {
      title: 'Returns & Exchanges',
      description: '7-day trial period with unconditional returns/exchanges (excluding human damage and opened consumables)'
      ,
      appreciationPeriod: {
        title: 'Appreciation Period',
        description: 'Within 7 days from the day after receipt, returns/exchanges may be requested; for inspection only, not for trial use',
        conditions: 'Please keep the product intact with all accessories, and no human damage'
      },
      returnProcess: {
        title: 'Return/Exchange Process',
        steps: [
          'Contact customer service to request a return/exchange',
          'Customer service confirms and provides return instructions',
          'Send back the product and provide the tracking number',
          'Refund/replacement is processed after inspection'
        ],
        refundTime: 'Refund will be processed within 3-7 business days after receiving and inspection'
      }
    },
    packageTracking: {
      title: 'Package Tracking',
      description: 'After shipment, you can track the package progress via the tracking number',
      queryMethods: {
        title: 'Query Methods',
        homeDelivery: {
          title: 'Home Delivery',
          description: 'Go to the carrier website and enter the tracking code to query',
          button: 'Go to Query'
        },
        convenienceStore: {
          title: 'Convenience Store',
          description: 'Use the code in the SMS/notification at the store system',
          sevenEleven: '7-11 Query',
          familyMart: 'FamilyMart Query'
        }
      },
      pickupNotes: {
        title: 'Pickup Notes',
        homeDelivery: 'Please check the carton on receipt; take photos if damaged',
        convenienceStore: 'Please pick up within 3 days after arrival notice',
        importantNote: 'If overdue, the parcel returns and a second shipping fee may be charged'
      }
    },
    contact: {
      title: 'Contact Us',
      serviceEmail: {
        title: 'Service Email',
        address: 'service@ventosano.com'
      },
      servicePhone: {
        title: 'Customer Service Phone',
        number: '(02) 7730-8767'
      },
      lineService: {
        title: 'LINE Customer Service',
        id: '@ventosano'
      },
      serviceHours: 'Mon–Fri 09:30–18:00 (Closed on public holidays)'
    },
    // Flat alias for direct access to specific payment options
    paymentMethods: {
      title: 'Payment Methods',
      description: 'We provide multiple safe and convenient payment options',
      mobilePayment: {
        title: 'Mobile Payment',
        description: 'Supports Apple Pay, Google Pay and multiple wallets',
        note: 'Actual supported wallets are subject to the checkout modal display'
      },
      convenienceStore: {
        title: 'Convenience Store Payment',
        description: 'Supports 7-11, FamilyMart, Hi-Life code/barcode payments',
        note: 'Payment code/barcode validity and fees follow convenience store rules'
      },
      cod: {
        title: 'Cash on Delivery',
        description: 'Pay in cash upon home delivery',
        note: 'Unavailable for some regions/large items; see checkout modal for availability'
      },
      creditCard: {
        title: 'Credit Card Payment',
        description: 'Supports Visa, MasterCard, JCB and other major cards',
        note: 'Some banks may not support installments/overseas cards; subject to authorization result'
      },
      bankTransfer: {
        title: 'Bank Transfer',
        description: 'ATM transfer or online banking transfer',
        note: 'Please include the order number in transfer notes to speed up reconciliation'
      },
      cashOnDelivery: {
        title: 'Cash on Delivery',
        description: 'Pay in cash upon home delivery',
        note: 'Availability may vary by region/product; see checkout modal'
      }
    },
    // Flat alias for shipping and fees
    shipping: {
      title: 'Shipping Methods',
      description: 'Fast and secure delivery service',
      deliveryTypes: {
        homeDelivery: 'Home Delivery',
        convenienceStore: 'Convenience Store Pickup'
      },
      shippingFees: {
        title: 'Shipping Fee Information',
        homeDelivery: {
          title: 'Home Delivery Shipping Fee',
          description: 'A shipping fee is charged below the free-shipping threshold; promotions per page announcement'
          ,
          mainIsland: 'Main Island',
          outlyingIslands: 'Outlying Islands'
        },
        convenienceStore: {
          title: 'Convenience Store Pickup Fee',
          mainIsland: 'Main Island',
          outlyingIslands: 'Outlying Islands'
        },
        convenienceStorePickup: {
          title: 'Convenience Store Pickup Fee',
          description: 'Flat fee for convenience store pickup; free for orders meeting threshold or promo'
        },
        storePickup: {
          title: 'Store Pickup',
          description: 'Free of charge; please pick up during business hours'
        }
      }
      ,
      shippingTime: {
        title: 'Shipping Time',
        description: 'In-stock orders ship within 24 hours; home delivery ~1-2 business days; remote areas/holidays may be delayed',
        sameDay: 'Orders paid before noon ship the same day',
        nextDay: 'Typically delivered the next business day',
        homeDelivery: 'Home delivery: Main island 1-2 business days, outlying 2-4',
        convenienceStore: 'Convenience store: pick up within 3 days after arrival notice',
        remoteAreas: 'Remote/mountain areas may take longer',
        notes: [
          'Actual arrival time depends on the carrier',
          'Delays may occur during severe weather/holidays',
          'Outlying islands and remote areas take longer'
        ]
      }
    },
    sections: {
      payment: {
        title: 'Payment Methods',
        description: 'We offer various safe and convenient payment methods',
        methods: [
          {
            title: 'Credit Card Payment',
            description: 'Supports Visa, MasterCard, JCB and other major credit cards',
            icon: 'credit-card'
          },
          {
            title: 'Bank Transfer',
            description: 'ATM transfer or online banking transfer',
            icon: 'bank'
          },
          {
            title: 'Cash on Delivery',
            description: 'Pay in cash when delivered to your door',
            icon: 'truck'
          }
        ]
      },
      shipping: {
        title: 'Shipping Methods',
        description: 'Fast and secure delivery service',
        methods: [
          {
            title: 'Home Delivery',
            description: 'Shipped within 24 hours, delivered in 1-2 business days',
            icon: 'home'
          },
          {
            title: 'Convenience Store Pickup',
            description: 'Pick up at 7-11, FamilyMart, Hi-Life and other convenience stores',
            icon: 'shop'
          },
          {
            title: 'Store Pickup',
            description: 'Pick up at Taipei store',
            icon: 'store'
          }
        ]
      },
      return: {
        title: 'Return Policy',
        description: '7-day trial period, unconditional return and exchange',
        conditions: [
          'Can apply for return/exchange within 7 days of receiving the product',
          'Product must maintain complete packaging and accessories',
          'Full refund for non-human damage',
          'Shipping costs borne by us'
        ]
      }
    }
  },


  // Customer Service
  customerService: {
    title: 'Customer Service',
    myConversations: 'My Conversations',
    createConversation: 'New Conversation',
    conversationTitle: 'Conversation Title',
    conversationType: 'Issue Type',
    conversationDescription: 'Issue Description',
    submit: 'Submit',
    cancel: 'Cancel',
    status: {
      OPEN: 'Open',
      PENDING: 'Pending',
      CLOSED: 'Closed'
    },
    types: {
      PRODUCT: 'Product Issue',
      ORDER: 'Order Issue',
      TECHNICAL: 'Technical Issue',
      OTHER: 'Other Issue'
    },
    timeFormat: {
      justNow: 'Just now',
      minutesAgo: 'minutes ago',
      hoursAgo: 'hours ago',
      daysAgo: 'days ago'
    },
    messages: {
      loadFailed: 'Failed to load conversation list',
      loadMessagesFailed: 'Failed to load messages',
      createSuccess: 'Conversation created successfully',
      createFailed: 'Failed to create conversation',
      sendFailed: 'Failed to send message',
      typeMessage: 'Type a message...',
      send: 'Send'
    },
    chatWidget: {
      title: 'Customer Service',
      expand: 'Expand',
      minimize: 'Minimize',
      noMessages: 'No messages yet. Start a conversation!',
      userAvatar: 'Me',
      staffAvatar: 'CS',
      inputPlaceholder: 'Type a message...'
    }
  },
  payment: {
    title: 'Payment Method',
    selectMethod: 'Cash on Delivery (COD)',
    methods: {
      cod: 'Cash on Delivery'
    },
    processing: 'Processing...',
    success: 'Order created successfully!',
    error: 'Order creation failed, please try again',
    security: 'We will contact you for payment upon delivery'
  },

  // Privacy Policy
  privacyPolicy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last Updated: October 6, 2024 | Effective Date: October 6, 2024',
    downloadPDF: 'Download PDF Version',
    back: 'Back',
    
    sections: {
      overview: {
        title: '1. Overview',
        content: 'This privacy policy explains how Flexible Negative Pressure Nasal Irrigator ("we," "our," or "company") collects, uses, stores, and protects your personal information. We are committed to protecting your privacy rights and complying with applicable data protection laws, including the European Union General Data Protection Regulation (GDPR), California Consumer Privacy Act (CCPA), and UK General Data Protection Regulation (UK-GDPR).'
      },
      
      informationCollection: {
        title: '2. Information We Collect',
        directlyProvided: {
          title: '2.1 Information You Provide Directly',
          items: [
            'Account Information: Name, email address, phone number, password',
            'Order Information: Shipping address, payment information, order history',
            'Communication Information: Records of your communications with our customer service',
            'Preference Settings: Language preferences, notification settings'
          ]
        },
        automaticallyCollected: {
          title: '2.2 Automatically Collected Information',
          items: [
            'Device Information: IP address, browser type, operating system',
            'Usage Data: Page visit records, click behavior, dwell time',
            'Cookies and Similar Technologies: Used to improve user experience and website functionality'
          ]
        }
      },
      
      informationUsage: {
        title: '3. Purpose of Information Usage',
        content: 'We use the collected information for the following purposes:',
        purposes: [
          'Provide, maintain, and improve our services',
          'Process orders and payments',
          'Customer service and support',
          'Send important notifications and updates',
          'Personalize user experience',
          'Legal compliance and risk management',
          'Marketing and promotion (with your consent)'
        ]
      },
      
      legalBasis: {
        title: '4. Legal Basis for Data Processing (GDPR/UK-GDPR)',
        items: [
          'Consent: You have explicitly consented to our processing of your personal data',
          'Contract Performance: Necessary for the performance of a contract with you',
          'Legal Obligation: Compliance with applicable legal requirements',
          'Legitimate Interest: Our legitimate business interests (such as security, fraud prevention)'
        ]
      },
      
      informationSharing: {
        title: '5. Information Sharing',
        content: 'We do not sell your personal information. We may share information in the following circumstances:',
        scenarios: [
          'Service Providers: Third parties who help us operate our business (such as payment processors, logistics companies)',
          'Legal Requirements: Compliance with legal obligations or responding to legal processes',
          'Business Transfers: In the event of mergers, acquisitions, or asset sales',
          'Consent: With your explicit consent'
        ]
      },
      
      dataSecurity: {
        title: '6. Data Security',
        content: 'We employ industry-standard security measures to protect your personal information, including:',
        measures: [
          'SSL/TLS encrypted transmission',
          'Secure data storage',
          'Access control and permission management',
          'Regular security audits',
          'Employee data protection training'
        ]
      },
      
      dataRetention: {
        title: '7. Data Retention',
        content: 'We retain your personal information only for as long as necessary to achieve the purposes for which it was collected. Specific retention periods are as follows:',
        periods: [
          'Account Information: Active account period + 3 years',
          'Order Records: 7 years (tax and legal requirements)',
          'Marketing Data: Until you withdraw consent',
          'Website Logs: 12 months'
        ]
      },
      
      yourRights: {
        title: '8. Your Rights',
        gdpr: {
          title: '8.1 GDPR/UK-GDPR Rights',
          rights: [
            'Right of Access: Obtain a copy of the personal data we hold about you',
            'Right of Rectification: Request correction of inaccurate personal data',
            'Right of Erasure: Request deletion of your personal data ("right to be forgotten")',
            'Right to Restrict Processing: Restrict how we process your personal data',
            'Right to Data Portability: Obtain your data in a structured, commonly used format',
            'Right to Object: Object to data processing based on legitimate interests',
            'Withdraw Consent: Withdraw your consent at any time'
          ]
        },
        ccpa: {
          title: '8.2 CCPA Rights (California Residents)',
          rights: [
            'Right to Know: Understand the categories of personal information we collect',
            'Right to Access: Obtain the personal information we have collected about you',
            'Right to Delete: Request deletion of your personal information',
            'Right to Opt-Out: Choose not to sell your personal information',
            'Right to Non-Discrimination: Not be discriminated against for exercising your rights'
          ]
        }
      },
      
      cookies: {
        title: '9. Cookies and Tracking Technologies',
        content: 'We use cookies and similar technologies to improve your website experience. You can manage your cookie preferences through your browser settings.',
        types: [
          'Essential Cookies: Necessary for basic website functionality',
          'Functional Cookies: Remember your preference settings',
          'Analytics Cookies: Help us understand website usage',
          'Marketing Cookies: Provide personalized advertising (requires consent)'
        ]
      },
      
      internationalTransfer: {
        title: '10. International Data Transfers',
        content: 'Your personal information may be transferred to locations outside your country/region for processing. We ensure such transfers comply with applicable data protection laws and implement appropriate security measures.'
      },
      
      childrenPrivacy: {
        title: '11. Children\'s Privacy',
        content: 'Our services are not directed to children under 13 years of age. We do not knowingly collect personal information from children under 13. If we discover that we have collected such information, we will delete it immediately.'
      },
      
      policyUpdates: {
        title: '12. Privacy Policy Updates',
        content: 'We may update this privacy policy from time to time. Significant changes will be notified to you via email or website. We recommend that you review this policy regularly to stay informed of the latest information.'
      },
      
      contactUs: {
        title: '13. Contact Us',
        content: 'If you have any questions about this privacy policy or wish to exercise your rights, please contact us through the following methods:',
        contactInfo: [
          'Email: privacy@nasal-irrigator.com',
          'Phone: +886-2-1234-5678',
          'Address: No. 7, Section 5, Xinyi Road, Xinyi District, Taipei City, Taiwan'
        ],
        dpo: 'Data Protection Officer (DPO): If you are an EU or UK resident, you can also contact our Data Protection Officer: dpo@nasal-irrigator.com'
      },
      
      regulatoryComplaints: {
        title: '14. Regulatory Authority Complaints',
        content: 'If you believe we have violated data protection laws, you have the right to file a complaint with the relevant regulatory authorities:',
        authorities: [
          'EU: Data protection authority in your member state',
          'UK: Information Commissioner\'s Office (ICO)',
          'California: California Attorney General\'s Office'
        ]
      },
      
      footer: {
        content: 'This privacy policy constitutes the complete agreement between us regarding the processing of personal information. By using our services, you agree to the terms of this privacy policy.'
      }
    }
  },

  // Delete Account Page
  deleteAccount: {
    title: 'Delete Account',
    subtitle: 'Please confirm that you want to delete your account. This action cannot be undone.',
    
    steps: {
      enterEmail: 'Enter Email',
      verifyCode: 'Verify Code',
      confirm: 'Confirm Deletion'
    },
    
    warning: {
      title: 'Important Notice',
      description: 'After deletion, you will not be able to recover your account data, including order records, coupons, personal information, etc. Please proceed with caution.'
    },
    
    email: {
      label: 'Email Address',
      placeholder: 'Please enter your registered email',
      required: 'Please enter email address',
      invalid: 'Please enter a valid email address'
    },
    
    verification: {
      label: 'Verification Code',
      placeholder: 'Please enter 4-digit verification code',
      required: 'Please enter verification code',
      length: 'Verification code must be 4 digits',
      sent: 'Verification code has been sent, please check your email',
      resent: 'Verification code has been resent',
      sendFailed: 'Failed to send verification code',
      cooldown: 'Please wait 1 minute before resending',
      maxAttempts: 'Maximum attempts reached, please try again later'
    },
    
    sendVerification: 'Send Verification Code',
    resendVerification: 'Resend Verification Code',
    confirmDelete: 'Confirm Deletion',
    backToEmail: 'Back to Email',
    
    delete: {
      success: 'Account has been successfully deleted',
      failed: 'Account deletion failed, please try again'
    },
    
    footer: {
      note: 'If you have any questions, please contact customer service'
    }
  },

  // Product Catalog Page
  productCatalog: {
    title: 'Taiwan Product Catalog',
    subtitle: 'Showcasing all quality products from Taiwan',
    searchPlaceholder: 'Search products...',
    selectCategory: 'Select Category',
    priceRange: 'Price Range',
    sortBy: 'Sort By',
    resetFilters: 'Reset Filters',
    view: 'View',
    addToCart: 'Add to Cart',
    added: 'Added',
    inStock: 'In Stock',
    outOfStock: 'Out of Stock',
    stock: 'Stock',
    noProductsFound: 'No products found',
    priceRanges: {
      range1: 'NT$0 - NT$100',
      range2: 'NT$100 - NT$300',
      range3: 'NT$300 - NT$500',
      range4: 'NT$500 - NT$1000',
      range5: 'NT$1000+'
    },
    sortOptions: {
      nameAsc: 'Name A-Z',
      nameDesc: 'Name Z-A',
      priceAsc: 'Price Low to High',
      priceDesc: 'Price High to Low',
      newest: 'Newest First'
    },
    pagination: {
      showTotal: 'Items {start}-{end} of {total}'
    },
    messages: {
      loadFailed: 'Failed to load products',
      insufficientStock: 'Insufficient stock',
      addedToCart: 'Item added to cart',
      viewProduct: 'View product: {name}'
    }
  },

  // Product Detail Page
  productDetail: {
    loading: 'Loading...',
    notFound: 'Product not found',
    backToHome: 'Back to Home',
    breadcrumb: {
      home: 'Home',
      products: 'Product List'
    },
    images: {
      noImage: 'No image available'
    },
    info: {
      rating: 'Rating',
      reviews: 'reviews',
      limitedOffer: 'Limited Offer',
      features: {
        authentic: 'Authentic Guarantee',
        fastDelivery: 'Fast Delivery',
        returnPolicy: '7-Day Return Policy'
      },
      quantity: 'Quantity:',
      addToCart: 'Add to Cart',
      buyNow: 'Buy Now',
      favorite: 'Favorite',
      share: 'Share'
    },
    tabs: {
      description: 'Product Details',
      specifications: 'Specifications',
      reviews: 'User Reviews'
    },
    specifications: {
      name: 'Product Name',
      sku: 'Product SKU',
      category: 'Category',
      status: 'Status',
      inStock: 'In Stock',
      outOfStock: 'Out of Stock',
      noDescription: 'No product description available'
    },
    reviews: {
      stats: {
        averageRating: 'Average Rating',
        totalReviews: 'Total Reviews',
        ratingDistribution: 'Rating Distribution',
        stars: 'stars',
        reviews: 'reviews'
      },
      actions: {
        writeReview: 'Write Review',
        loginFirst: 'Please login first',
        alreadyReviewed: 'You have already reviewed this product'
      },
      list: {
        anonymousUser: 'Anonymous User',
        verifiedPurchase: 'Verified Purchase',
        helpful: 'Helpful',
        thankYou: 'Thank you for your feedback'
      },
      modal: {
        title: 'Write Review',
        rating: 'Rating',
        ratingRequired: 'Please select a rating',
        titleLabel: 'Review Title',
        titlePlaceholder: 'Give your review a title (optional)',
        content: 'Review Content',
        contentPlaceholder: 'Share your experience...',
        anonymous: 'Anonymous Review',
        submit: 'Submit Review',
        cancel: 'Cancel'
      },
      messages: {
        submitSuccess: 'Review submitted successfully, awaiting approval',
        submitFailed: 'Failed to submit review',
        fetchFailed: 'Failed to fetch review data',
        loginRequired: 'Please login first'
      }
    },
    messages: {
      productNotFound: 'Product not found',
      fetchFailed: 'Failed to fetch product details',
      loginRequired: 'Please login first',
      addToCartSuccess: 'Added {name} to cart',
      addToCartTrigger: 'Trigger open cart event'
    }
  }
};
